import { MainContentLayout } from 'shared/ui/layout';

import { EditTariff } from 'features/tariff/edit';

export function EditTariffPage() {
  return <MainContentLayout element={<EditTariff />} />;
}
